export function isClassProvider(provider) {
    return !!provider.useClass;
}
